import { render, staticRenderFns } from "./BibliographySearchResultsSimpleTable.vue?vue&type=template&id=3d33c5a4&"
import script from "./BibliographySearchResultsSimpleTable.vue?vue&type=script&lang=ts&"
export * from "./BibliographySearchResultsSimpleTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports